import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { Checkbox } from '@zocdoc-frontend-common/components-checkbox';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

export class OBGYNConfirmationView extends Component {
    static propTypes = {
        professionalName: PropTypes.string.isRequired,
        insuranceName: PropTypes.string.isRequired,
        trackClickObgynWarning: PropTypes.func.isRequired,
    };

    buildStatement(professionalName) {
        return (
            `I understand that ${professionalName} is an OBGYN and ` +
            'usually only treats female patients. I want to make this appointment anyway.'
        );
    }

    renderMessage = () => {
        const { invalidMessage } = this.props;

        if (invalidMessage && invalidMessage.defaultMessage) {
            return invalidMessage.defaultMessage;
        }

        return invalidMessage;
    };

    render() {
        const {
            professionalName,
            isChecked,
            onCheck,
            trackClickObgynWarning,
        } = this.props;

        return (
            <FormRow>
                <Checkbox
                    checked={isChecked}
                    invalidMessage={this.renderMessage()}
                    onChecked={value => {
                        onCheck(value);
                        trackClickObgynWarning();
                    }}
                >
                    <Confirmation>
                        {this.buildStatement(professionalName)}
                    </Confirmation>
                </Checkbox>
            </FormRow>
        );
    }
}

const Confirmation = styled.span`
    font: 13px/20px ${FontFamily.SharpSansMedium};
`;
